/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedPersonDTO } from './ReferencedPersonDTO';
import {
    ReferencedPersonDTOFromJSON,
    ReferencedPersonDTOFromJSONTyped,
    ReferencedPersonDTOToJSON,
    ReferencedPersonDTOToJSONTyped,
} from './ReferencedPersonDTO';
import type { EmploymentPeriodDTO } from './EmploymentPeriodDTO';
import {
    EmploymentPeriodDTOFromJSON,
    EmploymentPeriodDTOFromJSONTyped,
    EmploymentPeriodDTOToJSON,
    EmploymentPeriodDTOToJSONTyped,
} from './EmploymentPeriodDTO';

/**
 * 
 * @export
 * @interface OrganisationToPersonDTO
 */
export interface OrganisationToPersonDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrganisationToPersonDTO
     */
    id?: number;
    /**
     * 
     * @type {ReferencedPersonDTO}
     * @memberof OrganisationToPersonDTO
     */
    person?: ReferencedPersonDTO;
    /**
     * 
     * @type {Array<EmploymentPeriodDTO>}
     * @memberof OrganisationToPersonDTO
     */
    employmentPeriods?: Array<EmploymentPeriodDTO>;
}

/**
 * Check if a given object implements the OrganisationToPersonDTO interface.
 */
export function instanceOfOrganisationToPersonDTO(value: object): value is OrganisationToPersonDTO {
    return true;
}

export function OrganisationToPersonDTOFromJSON(json: any): OrganisationToPersonDTO {
    return OrganisationToPersonDTOFromJSONTyped(json, false);
}

export function OrganisationToPersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationToPersonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'person': json['person'] == null ? undefined : ReferencedPersonDTOFromJSON(json['person']),
              'employmentPeriods': json['employmentPeriods'] == null ? undefined : ((json['employmentPeriods'] as Array<any>).map(EmploymentPeriodDTOFromJSON)),
    };
}

export function OrganisationToPersonDTOToJSON(json: any): OrganisationToPersonDTO {
    return OrganisationToPersonDTOToJSONTyped(json, false);
}

export function OrganisationToPersonDTOToJSONTyped(value?: OrganisationToPersonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'person': ReferencedPersonDTOToJSON(value['person']),
        'employmentPeriods': value['employmentPeriods'] == null? value['employmentPeriods']: (value['employmentPeriods'] as Array<any>).map(EmploymentPeriodDTOToJSON),
    };
}


